module.exports = __webpack_public_path__ + "icons/original/large/large-b2.f088bd5349ae94f3aecf2256a2a41f9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-b2.png
// module id = w35o
// module chunks = app